export default "<div class=\"iscroll-wrapper\" #scrollWrapper>\n    <div class=\"iscroll-scroller\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"